'use client';

import { ArrowLeftIcon, ArrowRightIcon } from '@repo/icons';
import { Button } from '@repo/ui/button';
import { useCarousel } from '@repo/ui/carousel';
import { cn } from '@repo/utils/cn';
import { useTranslations } from 'next-intl';
import { UnStyledLink } from '@/components/common/link';
import useCarouselVisibility from '@/hooks/useCarouselButtonsVisibility';

type HeaderCarouselButtonsProps = {
  type?: string;
  gamesLength?: number;
};

export const HeaderCarouselButtons = ({ type, gamesLength = 0 }: HeaderCarouselButtonsProps) => {
  const t = useTranslations('common');
  const { showViewAll, showCarouselButtons } = useCarouselVisibility(gamesLength, type);

  const { scrollNext, scrollPrev, canScrollPrev, canScrollNext } = useCarousel();

  return (
    <>
      {showViewAll && (
        <Button
          asChild
          variant="grey"
          className="pr-0 sm:pr-3"
        >
          <UnStyledLink href={`/casino/${type}`}>{t('view-all')}</UnStyledLink>
        </Button>
      )}
      {showCarouselButtons && (
        <>
          <button
            onClick={scrollPrev}
            disabled={!canScrollPrev}
            className={cn(
              'order-1 m-0 hidden size-[25px] items-center justify-center rounded-full border-none p-0 vt-atoms-arrow-text vt-atoms-arrow-bg vt-atoms-arrow-stroke hover:vt-atoms-arrow-text-hover hover:vt-atoms-arrow-bg-hover hover:vt-atoms-arrow-stroke-hover active:vt-atoms-arrow-text-active active:vt-atoms-arrow-bg-active active:vt-atoms-arrow-stroke-active sm:flex',
              {
                'disabled:vt-atoms-arrow-text-disabled disabled:vt-atoms-arrow-bg-disabled disabled:vt-atoms-arrow-stroke-disabled':
                  !canScrollPrev,
              }
            )}
          >
            <ArrowLeftIcon className="rtl:rotate-180" />
          </button>
          <button
            onClick={scrollNext}
            disabled={!canScrollNext}
            className={cn(
              'order-1 m-0 hidden size-[25px] items-center justify-center rounded-full border-none p-0 vt-atoms-arrow-text vt-atoms-arrow-bg vt-atoms-arrow-stroke hover:vt-atoms-arrow-text-hover hover:vt-atoms-arrow-bg-hover hover:vt-atoms-arrow-stroke-hover active:vt-atoms-arrow-text-active active:vt-atoms-arrow-bg-active active:vt-atoms-arrow-stroke-active sm:flex',
              {
                'disabled:vt-atoms-arrow-text-disabled disabled:vt-atoms-arrow-bg-disabled disabled:vt-atoms-arrow-stroke-disabled':
                  !canScrollPrev,
              }
            )}
          >
            <ArrowRightIcon className="rtl:rotate-180" />
          </button>
        </>
      )}
    </>
  );
};
